import React from "react";
import { motion } from "framer-motion";
import { SectionWrapper } from "../hoc";
import { skillTree } from "../constants";
import { styles } from "../styles";
import { fadeIn, textVariant } from "../utils/motion";

const SkillChip = ({ name, icon: Icon, image }) => (
  <div className="flex items-center gap-2.5 px-3.5 py-2 bg-[#0F0F0F] rounded-xl border border-white/5 hover:border-[#915eff]/40 hover:bg-[#141414] transition-all duration-200">
    {Icon ? (
      <Icon size={22} className="shrink-0" />
    ) : image ? (
      <img src={image} alt={name} className="w-[22px] h-[22px] shrink-0 object-contain" />
    ) : (
      <span className="w-[22px] h-[22px] shrink-0 flex items-center justify-center rounded-md bg-[#915eff]/15 text-[9px] font-bold text-[#915eff] uppercase">
        {name.slice(0, 2)}
      </span>
    )}
    <span className="text-white/90 text-sm whitespace-nowrap">{name}</span>
  </div>
);

const TreeBranch = ({ branch, index, isLast }) => (
  <motion.div
    variants={fadeIn("right", "spring", index * 0.2, 0.65)}
    className={`relative pl-12 md:pl-16 ${isLast ? "pb-0" : "pb-12"}`}
  >
    <span
      className="absolute left-[11px] md:left-[15px] top-0 w-4 h-4 md:w-5 md:h-5 rounded-full border-[3px] border-[#915eff] bg-[#0A0A0A] z-10"
      aria-hidden="true"
    />
    {!isLast && (
      <span
        className="absolute left-[18px] md:left-[22px] top-4 md:top-5 bottom-0 w-[2px] bg-gradient-to-b from-[#915eff] to-[#3b82f6]"
        aria-hidden="true"
      />
    )}

    <div
      className="bg-[#0A0A0A] p-5 md:p-6 rounded-xl border border-transparent hover:bg-[#0F0F0F] transition-colors duration-300"
      style={{
        borderImage:
          "linear-gradient(to right, rgb(147, 51, 234), rgb(59, 130, 246)) 1",
      }}
    >
      <h3 className="text-[#915eff] font-bold text-lg md:text-xl tracking-wide">
        {branch.label}
      </h3>
      <div className="mt-4 flex flex-wrap gap-3">
        {branch.skills.map((skill) => (
          <SkillChip key={skill.name} {...skill} />
        ))}
      </div>
    </div>
  </motion.div>
);

const Tech = () => {
  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}>Technical skills</p>
        <h2 className={styles.sectionHeadText}>Tech Stack</h2>
      </motion.div>

      <div className="mt-20 max-w-3xl mx-auto">
        {skillTree.map((branch, index) => (
          <TreeBranch
            key={branch.id}
            branch={branch}
            index={index}
            isLast={index === skillTree.length - 1}
          />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Tech, "tech");
